module.exports = __webpack_public_path__ + "static/img/janghyung-labor-management.c89906d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/janghyung-labor-management.jpg
// module id = EfIw
// module chunks = 0